module.exports = __webpack_public_path__ + "Roboto-LightItalic.1a9e39e536aed26b863b.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.svg
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-LightItalic.svg
// module chunks = styles